<div mat-dialog-container>
  <div
    class="flex items-center justify-between p-4 border-gray-200"
    mat-dialog-title
  >
    <div>
      <h2 class="m-0 text-xl">
        @if (ui.titleLabel) {
          <span class="mr-2 font-light">{{ ui.titleLabel }}:</span>
        }
        <span class="font-semibold">{{ ui.title }}</span>
      </h2>
      @if (ui.subtitle) {
        <h3 class="text-sm font-medium text-gray-600">
          @if (ui.subtitleLabel) {
            <span class="mr-2 font-light">{{ ui.subtitleLabel }}:</span>
          }
          <span class="font-medium">{{ ui.subtitle }}</span>
        </h3>
      }
      @if (ui.description) {
        <p class="text-xs font-extralight">
          {{ ui.description }}
        </p>
      }
    </div>
    <div class="flex items-center justify-end space-x-2">
      <art-items-export-button
        [items]="dataSource.filteredData"
        [title]="`Seznam položek - ${ui.titleLabel} - ${ui.title}`"
      ></art-items-export-button>

      <button mat-icon-button (click)="close()">
        <mat-icon svgIcon="mat:close"></mat-icon>
      </button>
    </div>
  </div>
  <div
    class="sticky left-0 flex items-center justify-between px-6 border-b h-14 bg-app-bar"
  >
    <h2 class="text-lg">{{ ui.tableTitle }}</h2>
    <div
      class="bg-foreground rounded-full border px-4 max-w-[300px] flex-auto flex items-center border-gray-300"
    >
      <mat-icon class="icon-sm text-secondary" svgIcon="mat:search"></mat-icon>
      <input
        [formControl]="searchCtrl"
        class="w-full px-4 py-2 bg-transparent border-0 outline-none"
        placeholder="Vyhledat..."
        type="search"
      />
    </div>
  </div>

  <mat-dialog-content class="overflow-y-auto">
    <table [dataSource]="dataSource" class="w-full" mat-table matSort>
      <!-- Image Column -->
      <ng-container matColumnDef="preview">
        <th
          *matHeaderCellDef
          class="sticky top-0 z-10 bg-white"
          mat-header-cell
        ></th>
        <td *matCellDef="let row" class="w-32 h-32 pr-0 min-w-8" mat-cell>
          <img
            [src]="pictureService.getMainPictureFullFilename(row) | photoProxy"
            class="object-scale-down w-32 h-32 align-middle"
            alt="Náhled díla"
            loading="lazy"
          />
        </td>
      </ng-container>

      <!-- Text Columns -->
      @for (column of TABLE_COLUMNS; track trackByProperty($index, column)) {
        @if (column.type === "text") {
          <ng-container [matColumnDef]="column.property">
            <th
              *matHeaderCellDef
              class="sticky top-0 z-10 text-left uppercase bg-white"
              mat-header-cell
              [mat-sort-header]="column.property"
              [disabled]="!availableSortColumns.includes(column.property)"
            >
              {{ column.label }}
            </th>
            <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>
              <div>
                @switch (column.property) {
                  @case ("title") {
                    <div>
                      <div>
                        {{ row.originalTitle }}
                      </div>
                    </div>
                  }
                  @case ("authors") {
                    <div>
                      <div>
                        {{ itemService.parseItemAuthors(row) }}
                      </div>
                    </div>
                  }
                  @case ("dating") {
                    <div>
                      {{ row.translations[0].dating }}
                    </div>
                  }
                  @case ("owner") {
                    <div>
                      @if (getItemCorrespondingOwner(row); as owner) {
                        <div>
                          @if (owner.ownerType) {
                            <span>{{ owner.ownerType.title }}</span>
                          }
                        </div>
                      }
                    </div>
                  }
                  @case ("yearPurchase") {
                    <div>
                      @if (getItemCorrespondingOwner(row); as owner) {
                        <div>
                          @if (ownerService.getYearOfPurchase(owner); as year) {
                            <div [matTooltip]="year.tooltip">
                              {{ year.label }}
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                  @case ("location") {
                    <div>
                      @if (
                        inventoryLocations &&
                          (locations?.length > 1 || type === "authors") &&
                          locationService.getLocationString(
                            row,
                            inventoryLocations
                          );
                        as location
                      ) {
                        <div [matTooltip]="location.tooltip">
                          {{ location.label }}
                        </div>
                      }
                    </div>
                  }
                  @case ("tag") {
                    <div>
                      <div class="flex flex-wrap gap-2">
                        @for (tag of getItemCorrespondingTags(row); track tag) {
                          <span
                            class="inline-block w-auto px-2 py-1 bg-gray-100 rounded-full"
                          >
                            {{ tag.titleCS }}
                          </span>
                        }
                      </div>
                    </div>
                  }
                  @case ("inventoryCode") {
                    <art-item-inventory-code
                      [item]="row"
                    ></art-item-inventory-code>
                  }
                  @default {
                    <div>
                      {{ row[column.property] }}
                    </div>
                  }
                }
              </div>
            </td>
          </ng-container>
        }
      }

      <!-- Action Column -->
      <ng-container matColumnDef="actions">
        <th
          *matHeaderCellDef
          class="sticky top-0 z-10 bg-white"
          mat-header-cell
          mat-sort-header
        ></th>
        <td *matCellDef="let row" class="w-10 text-secondary" mat-cell>
          <button
            class="hover:text-green-500"
            (click)="goToItemDetail(row.id)"
            mat-icon-button
            type="button"
            matTooltip="Přejít na detail díla"
          >
            <mat-icon svgIcon="mat:open_in_new"></mat-icon>
          </button>
          <button
            class="hover:text-blue-500"
            (click)="prepareItemQuickDialog(row)"
            mat-icon-button
            type="button"
            matTooltip="Zobrazit kartu díla"
          >
            <mat-icon svgIcon="mat:info"></mat-icon>
          </button>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
      <tr
        *matRowDef="let row; columns: visibleColumns"
        @fadeInUp
        class="w-5 h-20 hover:bg-hover trans-ease-out"
        [ngClass]="{
          'hover:bg-hover': !row.itemDisputationTypeId,
          'bg-blue-100 hover:bg-blue-200': row.itemDisputationTypeId === 1,
          'bg-red-100 hover:bg-red-200': row.itemDisputationTypeId === 2,
        }"
        mat-row
      ></tr>
    </table>
  </mat-dialog-content>
</div>
